import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import '@/style/index.less' // global css

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n


Vue.config.productionTip = false


Vue.prototype.$ELEMENT = { size: 'medium' }
Vue.use(ElementUI, { locale })


import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts;

import * as math from 'mathjs';
Vue.prototype.$math = math;

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
